import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../node_modules/driver.js/dist/driver.css'

import '../src/assets/styles/_element_ui.scss'

import '../src/assets/styles/common.scss'

import '../src/assets/styles/element-ui/index.scss'

import _77180f1e from '../src/layouts/blank.vue'
import _6f6c098b from '../src/layouts/default.vue'
import _4d8de3de from '../src/layouts/initial-setting.vue'
import _e5ef1d46 from '../src/layouts/maintenance.vue'
import _5c4c945c from '../src/layouts/sharing-content.vue'

const layouts = { "_blank": _77180f1e,"_default": _6f6c098b,"_initial-setting": _4d8de3de,"_maintenance": _e5ef1d46,"_sharing-content": _5c4c945c }

export default {
  head: {"title":"施工管理","htmlAttrs":{"lang":"ja"},"meta":[{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1.0"},{"hid":"description","name":"description","content":""},{"hid":"robots","name":"robots","content":"noindex,nofollow"}],"script":[{"type":"text\u002Fjavascript","async":true,"src":"https:\u002F\u002Fyubinbango.github.io\u002Fyubinbango-core\u002Fyubinbango-core.js"},{"type":"text\u002Fjavascript","async":true,"src":"https:\u002F\u002Fwww.google.com\u002Frecaptcha\u002Fenterprise.js"},{"type":"text\u002Fjavascript","async":true,"src":"https:\u002F\u002Fwww.google.com\u002Frecaptcha\u002Fenterprise.js?render=6LeDptEjAAAAAKDCObvgm0U0bHsktUi3IyW1hbbZ"},{"type":"text\u002Fjavascript","innerHTML":"window['ga-disable-G-YZK1TDG51E'] = true"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KT5X5VN')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-YZK1TDG51E","async":true}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Fandroid-chrome-256x256.png"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon.png"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons+Outlined"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Fhmt2sip.css"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KT5X5VN&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

  render(h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl])
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this
      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline() {
      return !this.isOnline
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
  components: {
    NuxtLoading
  }
}
